<template lang="pug">
  e-form-group(
  name="address"
  inputType="address"
  addressProvider="tree"
  :model="fields"
  :tabView="tabView"
  :required="required"
  :formGroupStyle="formGroupStyle"
  )
</template>

<script>
  import reportFieldMixin from '../../mixins/report-field-mixin'

  const ADDRESS_TREE_FIELDS = [
    'district_id',
    'city_id',
    'locality_id',
    'area_id',
    'street_id',
    'land_id',
    'house_id'
  ]

  export default {
    mixins: [reportFieldMixin],
    name: "address-tree",
    created () {
      ADDRESS_TREE_FIELDS.forEach(fName => {
        this.$set(this.fields, fName, '')
      })
    }
  }
</script>
